import React, { useState } from "react";
import { downloadFilingPackage } from "../../../api/filings/filingAPI";

/**
 * CompletedFilingPackage
 * Displays a download banner for completed tax filings (CUS role only)
 * Allows users to download or share their tax filing package
 */
function CompletedFilingPackage({ filingId, onDownload, onShare }) {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    if (isDownloading) return;

    setIsDownloading(true);

    try {
      const response = await downloadFilingPackage(filingId);

      if (response.ok) {
        // Get the blob from response
        const blob = await response.blob();

        // Extract filename from Content-Disposition header
        const contentDisposition = response.headers.get("Content-Disposition");
        let filename = "filing-package.zip"; // fallback

        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename="?(.+)"?/i);
          if (filenameMatch && filenameMatch[1]) {
            filename = filenameMatch[1].replace(/"/g, "");
          }
        }

        // Create download link
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();

        // Cleanup
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);

        // Call optional callback
        if (onDownload) {
          onDownload();
        }
      } else {
        // Handle error response
        const errorData = await response.json().catch(() => ({}));
        console.error("Download failed:", errorData);
        alert(
          errorData.detail || "Failed to download package. Please try again.",
        );
      }
    } catch (error) {
      console.error("Error downloading package:", error);
      alert("An error occurred while downloading. Please try again.");
    } finally {
      setIsDownloading(false);
    }
  };

  const handleShare = () => {
    console.log("Share Package clicked");
    if (onShare) {
      onShare();
    }
  };

  return (
    <div className="completed-filing-package">
      {/* Image */}
      <img
        src={`${process.env.PUBLIC_URL}/images/filing_package.svg`}
        alt="Tax Filing Package"
        className="completed-filing-package-image"
      />

      {/* Title - moved out for better responsive layout */}
      <h3 className="completed-filing-package-title">Tax Filing Package</h3>

      {/* CTA Buttons - direct child for responsive wrapping */}
      <div className="completed-filing-package-buttons">
        <button
          className="cta-button primary"
          onClick={handleDownload}
          disabled={isDownloading}
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={`${process.env.PUBLIC_URL}/images/icons/download_white.svg`}
            alt="Download"
            style={{ marginRight: "10px" }}
          />
          {isDownloading ? "Downloading..." : "Download Package"}
        </button>
        {/* Share Package button - commented out for now */}
        {/* <button 
          className="cta-button secondary" 
          onClick={handleShare}
        >
          Share Package
        </button> */}
      </div>
    </div>
  );
}

export default CompletedFilingPackage;
